import { FormRow } from '@tanium/react-form';
import { FormTextareaInput } from '@tanium/react-form-textarea-input';
import { Field, FieldProps, FormikErrors } from 'formik';
import get from 'lodash.get';
import { getNullableEventValue } from 'utils/Helper';

type FormTextAreaProps = {
  fieldName: string;
  label: string;
  description: string;
  placeholder: string;
  dataTestId?: string;
  required?: boolean;
};

const FormTextArea: React.VFC<FormTextAreaProps> = ({
  fieldName,
  label,
  description,
  placeholder,
  dataTestId,
  required,
}) => {
  let computedDataTestId = fieldName;
  if (dataTestId !== undefined) {
    computedDataTestId = dataTestId;
  }
  return (
    <Field name={fieldName}>
      {({ form, field }: FieldProps): React.ReactElement => (
        <FormRow
          label={label}
          description={description}
          labelId={field.name}
          required={required}
          errors={(get(form.touched, field.name) && get(form.errors, field.name)) as FormikErrors<string>}
        >
          <FormTextareaInput
            data-testid={computedDataTestId}
            style={{
              height: '3em',
            }}
            {...field}
            value={field.value || ''}
            onInput={(event) => form.setFieldValue(field.name, getNullableEventValue(event))}
            id={field.name}
            placeholder={placeholder}
            required={required}
          />
        </FormRow>
      )}
    </Field>
  );
};

export default FormTextArea;
